import React from 'react';

const createSchemaString = (type: string, data: Record<string, JSONValue>) =>
  JSON.stringify({
    '@context': 'https://schema.org',
    '@type': type,
    ...data,
  });

export const createLdJsonScript = (type: string, data: Record<string, JSONValue>) =>
  React.createElement('script', {
    type: 'application/ld+json',
    dangerouslySetInnerHTML: { __html: createSchemaString(type, data) },
  });
